import { render, staticRenderFns } from "./RouteSettings.vue?vue&type=template&id=42d1f9ec&scoped=true&"
import script from "./RouteSettings.vue?vue&type=script&lang=js&"
export * from "./RouteSettings.vue?vue&type=script&lang=js&"
import style0 from "./RouteSettings.vue?vue&type=style&index=0&id=42d1f9ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1f9ec",
  null
  
)

export default component.exports